/**
 * Smooth scroll to Product Trial section
 * Used by large-banner-trial and image-with-text sections
 */
function scrollToProductTrial(event) {
  if (event) {
    event.preventDefault();
  }
  
  const productTrialSection = document.getElementById('product-trial-section');
  
  if (productTrialSection) {
    const headerOffset = 80;
    const elementPosition = productTrialSection.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  } else {
    console.warn('Product Trial section not found on this page');
  }
}
